import React from 'react';
import { motion } from 'framer-motion';
import { InteriorSlide } from './SlideShell';
import type { SlideProps } from './SlideShell';
const CUSTOMER_JOURNEY_EXAMPLES = 'https://cdn.magicpatterns.com/uploads/e8bsBeDjTocGCKqA3TTNFt/Screenshot_2026-08-27_at_11.51.01.png';
export function SlideCustomerJourneyExamples({}: SlideProps) {
  return <InteriorSlide surface data-id="element-203" data-mp="ivylvhwodps8">
      <motion.header initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="mb-[clamp(1rem,1.8vw,1.75rem)] flex flex-shrink-0 items-end justify-between gap-8" data-id="element-204" data-mp="16lasca0mbjqu">
        <div data-id="element-205" data-mp="wuolp5avq3ka">
          <p className="mb-2 text-[clamp(0.7rem,1vw,0.9rem)] font-bold uppercase tracking-[0.2em] text-[var(--brand)]" data-id="element-206" data-mp="wv7qrlffkxgw">
            Experience portfolio
          </p>
          <h2 className="text-[clamp(2rem,3.4vw,3.3rem)] font-extrabold leading-tight tracking-[-0.04em] text-[var(--fg)]" data-id="element-207" data-mp="1pjvkm5e8wv62">
            Snaks throughout the{' '}
            <span className="text-[var(--brand)]" data-id="element-208" data-mp="2c8c44j574bli">customer journey</span>
          </h2>
        </div>
        <p className="hidden max-w-sm text-right text-sm leading-relaxed text-[var(--muted)] lg:block" data-id="element-209" data-mp="2797x9z5qupyc">
          Real examples spanning awareness, education, interaction, engagement,
          and insight generation.
        </p>
      </motion.header>

      <motion.figure initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.18,
      duration: 0.65
    }} className="flex min-h-0 flex-1 items-center justify-center overflow-hidden rounded-3xl border border-[var(--brand)]/10 bg-white p-3 shadow-sm" data-id="element-210" data-mp="2g94fpj1jisky">
        <img src={CUSTOMER_JOURNEY_EXAMPLES} alt="Examples of Snak experiences used throughout the customer journey" className="h-full w-full object-contain" data-id="element-211" data-mp="33ypar0ayxgal" />
      </motion.figure>
    </InteriorSlide>;
}